import { render, staticRenderFns } from "./CooperationDetails.vue?vue&type=template&id=079e9f32"
import script from "./CooperationDetails.vue?vue&type=script&lang=js"
export * from "./CooperationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports